<div
  class="ui attached segment"
  appMargin
  marginT="5"
  style="border: 1px solid #dcdcdc; border-radius: 4px"
  appPadding
  paddingX="40px"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxFlex="15">{{ account?.gatewayTransactionRefId || account?.transactionId }}</div>
    <div fxFlex="12">
      {{
      account?.status.includes("AWAITING")
      ? account?.description
      : "eWallet Withdrawal"
         }}
    </div>

    <div fxFlex="11">
      {{ currencyCode }} {{ (account?.totalAmount || account?.amount) | number: "1.2-2" }}
    </div>
    <div fxFlex="11">
      {{ currencyCode }} {{ (account?.unitAmount || account.totalCharges) || 0 | number: "1.2-2" }}
    </div>

    <div fxFlex="12">
      <span
        class="ui yellow circular label"
        >{{ "PENDING" }}</span
      >
    </div>
    <div fxFlex="27">
      {{ account?.dateCreated | date: "medium" }}
    </div>
    <div fxFlex="12" class="text-right">
      <button class="ui circular icon button" (click)="viewDetails()">
        <!-- <i class="eye icon"></i> -->
        <img class="eye icon" src="../../../../../../../assets/icons/eye.svg" alt="eye icon">
      </button>
    </div>
  </div>
</div>
